import { forwardRef } from 'react';
import { ReactKit } from '@team/react';
import { Text } from '../../../../typography/text';
import { type HeaderProps } from '../../types';
import { Handle } from '../handle';
import css from './style.module.css';

export const Layout = forwardRef<HTMLElement, HeaderProps>(function Component(
  { before, children, after, preventCycle },
  forwardedRef
) {
  return (
    <header className={css.root} ref={forwardedRef}>
      <div className={css.before}>{before}</div>

      <div className={css.main}>
        <Handle preventCycle={preventCycle} />

        {ReactKit.hasNode(children) && (
          <Text weight={2} className={css.content} inline={false}>
            {children}
          </Text>
        )}
      </div>

      <div className={css.after}>{after}</div>
    </header>
  );
});
